import { render, staticRenderFns } from "./ImportFormatTable.vue?vue&type=template&id=712247cc&"
import script from "./ImportFormatTable.vue?vue&type=script&lang=js&"
export * from "./ImportFormatTable.vue?vue&type=script&lang=js&"
import style0 from "./ImportFormatTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports